import { render, staticRenderFns } from "./BodyPortal.vue?vue&type=template&id=61e35afe&scoped=true"
import script from "./BodyPortal.vue?vue&type=script&lang=js"
export * from "./BodyPortal.vue?vue&type=script&lang=js"
import style0 from "./BodyPortal.vue?vue&type=style&index=0&id=61e35afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e35afe",
  null
  
)

export default component.exports